import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme.ts';
import { Flex, Text } from '@mantine/core';
import { memo } from 'react';
import styled from 'styled-components';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface Props {
	className?: string;
	text: string;
	iconVariant?: PredefinedIcons;
}

const RectangleBadge = ({ iconVariant = 'document-v3', className, text }: Props) => {
	return (
		<Flex gap="0.5rem" align="center" className={className}>
			<Icon variant={iconVariant} size="lg" color={defaultTheme.v3.colors.dark[0]} />
			<Text size="B6Medium" c="dark.0">
				{text}
			</Text>
		</Flex>
	);
};

const Memoized = memo(RectangleBadge);
const Styled = styled(Memoized)`
	width: fit-content;
	padding: 0.5rem;
	background-color: ${defaultTheme.v3.colors.gray[0]};
	border: 1px solid ${defaultTheme.v3.colors.gray[2]};
	border-radius: 0.5rem;
`;

export { Styled as DocumentTypeBadge };
